<template>
  <div>
    <div v-if="device === 'mobile'" class="xs-not-container">
      <div class="xs-not-container-content">
        <div>
          <div>
            <img class="not-img" width="60%" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo_big.svg') : require('@/assets/logo/logo_big.svg')">
          </div>
          <div class="not-find-form-container">
            <div>
              <div class="text-not-find color-main-linear-blue">
                404 Not Found
              </div>
              <div class="not-find-content">
                The page you requested could not be found. It may have been moved or deleted
              </div>

              <div>
                <img class="not-find-bottom-logo" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo.png') : require('@/assets/logo/ezpay_logo.svg')">
                <div class="text-all-right">©️ {{ new Date().getFullYear() }} {{ $store.getters.isAruxpay ? 'Aruxpay' : 'Ezpay' }} Information Solutions <br> Corp., All Rights Reserved</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="not-find-container">
      <div class="not-find-form-container">
        <div>
          <div class="text-not-find color-main-linear-blue">
            404 Not Found
          </div>
          <div class="not-find-content">
            The page you requested could not be found.<br>  It may have been moved or deleted
          </div>

          <div>
            <img class="not-find-bottom-logo" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo.png') : require('@/assets/logo/ezpay_logo.svg')">
            <div class="text-all-right">©️ {{ new Date().getFullYear() }} {{ $store.getters.isAruxpay ? 'Aruxpay' : 'Ezpay' }} Information Solutions Corp., All Rights Reserved</div>
          </div>
        </div>
      </div>
      <div class="not-find-img">
        <img width="100%" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo_big.svg') : require('@/assets/logo/logo_big.svg')">
      </div>
    </div>

  </div>
</template>

<script>
const WIDTH = 992
const { body } = document
export default {
  name: 'Page404',
  data() {
    return {
      device: 'desktop'
    }
  },
  computed: {

  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
    const isMobile = this.$_isMobile()
    this.device = isMobile ? 'mobile' : 'desktop'
  },
  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_isMobile() {
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        this.device = isMobile ? 'mobile' : 'desktop'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-not-find{
  font-size: 64px;
  font-weight: 600;
  margin-bottom: 96px;
}
.not-find-bottom-logo{
  margin-top: 96px;
  height: 32px;
}
.text-all-right{
  margin-top: 24px;
  color: #5E6E82;
  font-size: 12px;
}
.not-find-content{
  color: #364250;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
}
.not-find-container {
  height: 100vh;
  width: 100%;
  background: #EDF2F9;
  overflow: hidden;
  display: flex;
  .not-find-img{
    // padding-top: 60px;
    width: 45%;
    min-height: 650px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
     .not-find-img-content{
       width: 80%;
     }
  }
  .not-find-form-container{
    position: relative;
    height: 100vh;
    width: 55%;
    display: flex;
    justify-content:center;
    align-items: center;
    overflow: hidden;
  }
}

.xs-not-container {
  height: 100vh;
  background: #EDF2F9;
  overflow: hidden;
  padding: 30px;
  padding-top: 275px;
  text-align: center;
  .not-img{
    position: absolute;
    top: 0;
    right: 0;
  }
  .text-not-find{
    font-size: 32px;
    text-align: left;
    margin-bottom: 24px;
  }
  .not-find-bottom-logo{
    margin-top: 48px;
    height: 32px;
  }
  .text-all-right{
    margin-top: 24px;
    color: #5E6E82;
    text-align: center;
    font-size: 12px;
  }
  .not-find-content{
    color: #364250;
    font-size: 12px;
    text-align: left;
    font-weight: 600;
    line-height: 1.5;
  }
}
</style>

